import { render, staticRenderFns } from "./AIFormattedText.vue?vue&type=template&id=069998d8&scoped=true&"
import script from "./AIFormattedText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIFormattedText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AIFormattedText.vue?vue&type=style&index=0&id=069998d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069998d8",
  null
  
)

export default component.exports